<template>
  <div class="wrapper">
    <sms ref="sendBox" v-if="sendBox === 'sms' && ! hideSendBox"
         @outbound-message-created="onOutboundMessageCreated"
         v-bind="getSmsProps"
    ></sms>
    <mail ref="sendBox" v-if="sendBox === 'mail' && ! hideSendBox"
          @outbound-message-created="onOutboundMessageCreated"
          v-bind="getMailProps"
    ></mail>
    <div class="mt-2">
      <button class="btn"
              @click.prevent="setSendBox('sms')"
              v-bind:class="[sendBox === 'sms' ? 'btn-purple' : 'btn-default']"
              :disabled="! isPossibleSendSms"
              v-if="canSendSms || canSendApprovedSms"
      >
        <el-tooltip content="The contact does not have a phone number" placement="top" effect="light" v-if="! contactHasPhoneNumber">
          <span>SMS</span>
        </el-tooltip>
        <span v-else>SMS</span>
      </button>
      <button class="btn"
              :disabled="! isPossibleSendEmail"
              @click.prevent="setSendBox('mail')"
              v-bind:class="[sendBox === 'mail' ? 'btn-purple' : 'btn-default']"
              v-if="canSendEmail"
      >
        <el-tooltip content="The contact does not have an email address" placement="top" effect="light" v-if="! contactHasEmailAddress">
          <span>Email</span>
        </el-tooltip>
        <span v-else>Email</span>
      </button>
      <OutboundCall
        :conversation="conversation"
        customClass="btn btn-default"
        v-if="canMakeCall"
        :disabled="! isPossibleMakeCall"
      >
        <el-tooltip content="The contact does not have a phone number" placement="top" effect="light" v-if="! contactHasPhoneNumber">
          <i class="fas fa-phone-alt"></i>
        </el-tooltip>
        <i v-else class="fas fa-phone-alt"></i>
      </OutboundCall>
    </div>
  </div>
</template>

<script>
import Sms from "./send-boxes/sms";
import Mail from "./send-boxes/mail";
import OutboundCall from "../call/outbound-call";
import {isFilled} from "../../helpers";
import eventBus from "../../event-bus";

export default {
  components: {
    Sms,
    Mail,
    OutboundCall,
  },

  props: {
    types: Object,
    conversation: Object,
    brand: Object,
    styles: Object,
  },

  data: function () {
    return {
      sendBox: null,
      hideSendBox: false,
    };
  },

  computed: {
    /**
     * @return {*}
     */
    getSmsProps() {
      let props = _.get(this.types, 'sms');

      return _.assign({}, props, {
        conversation: this.conversation,
        styles: this.styles,
        brand: this.brand,
        canSendMessage: _.get(this.conversation, 'canSendMessage'),
      });
    },

    /**
     * @return {*}
     */
    getMailProps() {
      let props = _.get(this.types, 'mail');

      return _.assign({}, props, {
        conversation: this.conversation,
        styles: this.styles,
        brand: this.brand,
      });
    },

    /**
     * @return {boolean}
     */
    canSendSms() {
      return Boolean(_.get(this.conversation, 'canSendMessage'));
    },

    /**
     * @return {boolean}
     */
    canSendApprovedSms() {
      return Boolean(_.get(this.types, 'sms.canSendApprovedMessage'));
    },

    /**
     * @return {boolean}
     */
    canSendEmail() {
      return Boolean(_.get(this.types, 'mail.canSendMessage'));
    },

    /**
     * @return {boolean}
     */
    canMakeCall() {
      return Boolean(_.get(this.types, 'call.canMakeCall'));
    },

    /**
     * @return {boolean}
     */
    contactHasPhoneNumber() {
      return isFilled(_.get(this.conversation, 'contact.phone_number'));
    },

    /**
     * @return {boolean}
     */
    contactHasEmailAddress() {
      return isFilled(_.get(this.conversation, 'contact.email'));
    },

    /**
     * @return {boolean}
     */
    isPossibleSendSms() {
      return (this.canSendSms || this.canSendApprovedSms) && this.contactHasPhoneNumber;
    },

    /**
     * @return {boolean}
     */
    isPossibleSendEmail() {
      return this.canSendEmail && this.contactHasEmailAddress;
    },

    /**
     * @return {boolean}
     */
    isPossibleMakeCall() {
      return this.canMakeCall && this.contactHasPhoneNumber;
    }
  },

  methods: {
    /**
     * @param box
     */
    setSendBox(box) {
      if (this.sendBox === box) {
        this.hideSendBox = ! this.hideSendBox;
      } else {
        this.hideSendBox = false;
      }

      this.sendBox = box;
    },

    /**
     * @param box
     * @return {Object}
     */
    getProps(box) {
      let props = _.get(this.types, box, this.sendBox);

      return _.assign({}, props, {
        conversation: this.conversation,
        styles: this.styles,
        brand: this.brand,
      });
    },

    /**
     * @emits outbound-message-created
     * @param data
     */
    onOutboundMessageCreated({data}) {
      this.$emit('outbound-message-created', data);
    },

    /**
     * @return {undefined}
     */
    clear() {
      this.$refs.sendBox.clearContent();
    },

    /**
     * @param message
     * @return {undefined}
     */
    setReplyTo({message}) {
      this.sendBox = 'mail';

      this.$nextTick(() => {
        this.$refs.sendBox.setReplyTo({message: message});
      });
    },
  },

  /**
   * @return {undefined}
   */
  beforeDestroy() {
    eventBus.$off('reply-to-email', this.setReplyTo);
  },

  /**
   * @return {undefined}
   */
  created() {
    if (this.isPossibleSendSms) {
      this.sendBox = 'sms';
    } else if (this.isPossibleSendEmail) {
      this.sendBox = 'mail';
    }

    eventBus.$on('reply-to-email', this.setReplyTo);
  },
}
</script>
